// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonExportDefault_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.9999 4.25 8.99989 6.5V2L11.9999 4.25ZM7.28648 4C6.70982 4.32697 6.19578 4.80717 5.84632 5.41246 5.46888 6.0662 5.30663 6.78594 5.33835 7.48794 5.37996 7.40143 5.4255 7.31521 5.47422 7.23082 6.21976 5.93951 7.53247 4.99972 8.99981 4.99972V3.5074C8.99064 3.5076 8.98146 3.50783 8.97227 3.50811 8.83692 3.51221 8.69997 3.52528 8.56256 3.54701 8.56008 3.5474 8.55761 3.54779 8.55513 3.54819 8.36995 3.57789 8.18398 3.6233 8 3.68365 7.88744 3.72058 7.77564 3.76309 7.66522 3.81102 7.6097 3.83512 7.55454 3.86058 7.4998 3.88739 7.4918 3.89132 7.4838 3.89527 7.47581 3.89925 7.41205 3.93102 7.3489 3.96461 7.28648 4Z" class="svg-bg"/>
  <path d="M0 3H6.06803C5.6746 3.28007 5.31351 3.61519 5.00249 4H1V10H10V7.62491L11 6.87491V11H0V3Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.9999 5L11.9999 2V4.00987C10.4347 4.04318 8.70069 4.98168 7.79525 6.54995C7.292 7.4216 7.07567 8.38125 7.11796 9.31725C7.17344 9.20191 7.23416 9.08695 7.29912 8.97443C8.29318 7.25267 10.0435 5.99962 11.9999 5.99962V8L15.9999 5Z" class="svg-bg"/>
  <path d="M8.0398 4H0V14H14V8.37493L12 9.87493V12H2V6H6.38523C6.42095 5.93293 6.45794 5.86623 6.49621 5.79994C6.90185 5.09736 7.43275 4.4925 8.0398 4Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M23.9998 7L17.9998 3V5.71823C16.0016 5.76336 13.7895 6.96216 12.6338 8.96386C11.9907 10.0777 11.7143 11.304 11.7683 12.5C11.8392 12.3526 11.9168 12.2057 11.9998 12.0619C13.2689 9.86382 15.5026 8.26354 17.9998 8.26064V11L23.9998 7Z" class="svg-bg"/>
  <path d="M16.3601 6C15.2336 6.35798 14.1473 7.04489 13.3209 8C13.5279 7.76073 13.751 7.53829 13.9871 7.33364C14.6936 6.72144 15.516 6.26838 16.3601 6Z" class="svg-bg"/>
  <path d="M12.4782 6H0V21H21V11.4033L19 12.7366V19H2V8H10.8808C10.8878 7.98785 10.8947 7.97572 10.9017 7.96359C11.3305 7.22098 11.8676 6.563 12.4782 6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonExportDefault is a generated icon component.
 */
let IconCommonExportDefault = IconCommonExportDefault_1 = class IconCommonExportDefault extends IconBaseElement {
    render() {
        return html `${IconCommonExportDefault_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonExportDefault.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonExportDefault = IconCommonExportDefault_1 = __decorate([
    customElement('zui-icon-common-export-default')
], IconCommonExportDefault);
export { IconCommonExportDefault };
